import React, { createElement, useCallback, useEffect, useMemo, useRef, useState } from 'react'
// import "@glideapps/glide-data-grid/dist/index.css";

import "@glideapps/glide-data-grid/dist/index.css";
import { DataEditor, GridCellKind, GridColumnIcon, GridColumnMenuIcon } from "@glideapps/glide-data-grid";
import './GlidGrid.css'
// import { StarCell } from "@glideapps/glide-data-grid-cells";
import { allCells } from "@glideapps/glide-data-grid-cells";
import { useEventListener } from './util'
import { Dialog } from 'primereact/dialog';
import ColumnConfigComp from '../../Pages/Utility/ColumnConfigComp';
import { ExcelGenerate } from '../../Pages/Utility/ExcelExportComp';
import excelIcon from '../../Asset/Image/svg/excel.svg'
import { HiChartSquareBar } from "react-icons/hi";
import saveIcon from '../../Asset/Image/saveIcon.png'
import settingicon from '../../Asset/Image/svg/settingIcon.svg'
import moment from 'moment';
import { IoGrid } from 'react-icons/io5';
import { addData as updateColumnConfig } from '../../Redux/Slices/Transaction/DynamicSlice.js'
import { useDispatch, useSelector } from 'react-redux';
import holdImage from '../../Asset/Image/svg/hold.svg'
import confirmImage from '../../Asset/Image/svg/confirm.svg'
import pdfImage from '../../Asset/Image/svg/pdf.svg';
import passResetpng from '../../Asset/Image/svg/PassReset.png';
import ChekSvg from '../../Asset/Image/svg/Chek.svg';
import RemoveFilter from '../../Asset/Image/svg/removeFilter.png';
import ChartPopup from '../../Pages/Utility/ChartPopup.jsx';
import { Tabs, Tab, Form, Button } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import { MdFilterAlt, MdFilterListAlt, MdOutlineClear } from 'react-icons/md';
import { RiFilterOffLine } from "react-icons/ri";
import { TbFileTypePdf } from "react-icons/tb";

function GlidGrid(props) {
    let { data, columns, GetselectedRow, height, getCellTheme, ActionButton, headerHeight, rowHeight, verticalBorder, hoverEffect, AddNewRecord, ViewparaName, ExcelGet, onCellDoubleClicked, Selection,
        SelectionColumn } = props;

    let [filterdata, setfilterdata] = useState(Array.isArray(data) && data[0])
    const [showSearch, setShowSearch] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState("")
    const [newDataColumns, setnewDataColumns] = useState(columns)
    const [freezeColumns, setfreezeColumns] = useState(0)
    const [SummaryRowCount, setSummaryRowCount] = useState(0)
    const [FormulaColumn, setFormulaColumn] = useState([])
    const [numRows, setNumRows] = React.useState(0)
    const [visible, setVisible] = useState(false);
    let possibleTags = "";
    const [selectedColorData, setselectedColorData] = useState({})
    const [filterColors, setfilterColors] = useState([])
    const [showChartPopup, setsowChartPopup] = useState(false)
    const dispatch = useDispatch();
    let [sortColumn, setsortColumn] = useState({ Index: -1, Sort: "" })
    let Setting = useSelector(state => state.Setting.Setting);
    let [selectedFilters, setSelectedFilters] = useState([])
    const [IsFilterApply, setIsFilterApply] = useState(false)
    const [selectedRows, setSelectedRows] = useState([]);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    // useEffect(() => {
    //     if (columns) {
    //         setnewDataColumns([...columns])
    //     }
    // }, [columns])

    const [hoverRow, setHoverRow] = React.useState(undefined)
    let [Modify_data, setModify_data] = useState({});

    possibleTags = [
        {
            tag: "Bug",
            color: "#ff4d4d35",
        },
        {
            tag: "Feature",
            color: "#35f8ff35",
        },
        {
            tag: "Enhancement",
            color: "#48ff5735",
        },
        {
            tag: "First Issue",
            color: "#436fff35",
        },
        {
            tag: "PR",
            color: "#e0ff3235",
        },
        {
            tag: "Assigned",
            color: "#ff1eec35",
        },
    ];

    useEffect(() => {
        const jsonString = data && JSON.stringify(data);
        filterdata = jsonString && JSON.parse(jsonString);
        setfilterdata(filterdata)
        FormulaRowAdd()
        Modify_data = {};
        setModify_data({})
        // applyFilter();
        sortFilterData(filterdata, sortColumn);

    }, [data])
    // useEffect(() => {
    //     if (data && data.length > 0) {
    //         let colData = columns.filter(column => {
    //             return column && Object.keys(data[0])?.some(key => key && key?.toString().toLowerCase() == column.id.toString().toLowerCase());
    //         });


    //         colData = colData?.map((x) => {
    //             return {
    //                 ...x,
    //                 hasMenu: true,
    //                 menuIcon: GridColumnMenuIcon.Dots,
    //                 overlayIcon: "rowOwnerOverlay"
    //             }

    //         })

    //         if (colData) {
    //             setnewDataColumns([...colData])
    //         }
    //         setfreezeColumns(colData?.filter(item => item.Isfreeze).length)
    //         FormulaRowAdd()
    //     }
    // }, [data, columns])

    const headerIcons = React.useMemo(() => {
        return {
            custom: () =>
                `<?xml version="1.0" ?><svg height="1792" viewBox="0 0 1792 1792" width="1792" xmlns="http://www.w3.org/2000/svg">
                <path 
                    d="M1595 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z" 
                    fill="#057eff"
                />
            </svg>`,
        };
    }, []);

    useEffect(() => {
        if (data && data?.length > 0) {
            let colData = columns?.filter(column => {
                return column && Object.keys(data[0])?.some(key =>
                    key?.toString()?.toLowerCase() === column.id?.toString()?.toLowerCase()
                );
            });
            colData = colData?.map((col) => {
                const colId = col.ColName?.toString()?.toLowerCase();
                const matchedFilterKey = Object.keys(selectedFilters || {}).find(filterKey =>
                    filterKey?.toString()?.toLowerCase() === colId
                );

                const hasActiveFilter = matchedFilterKey &&
                    (
                        (selectedFilters[matchedFilterKey]?.values?.length > 0) ||
                        (selectedFilters[matchedFilterKey]?.colors?.length > 0)
                    );

                return {
                    ...col,
                    hasMenu: true,
                    menuIcon: "dots",
                    icon: hasActiveFilter ? "custom" : undefined
                };
            });

            if (colData) {
                setnewDataColumns([...colData]);
            }

            setfreezeColumns(colData?.filter(item => item.Isfreeze).length);
            FormulaRowAdd();
        }
    }, [data, columns, IsFilterApply, selectedFilters]);


    const [showPopover, setShowPopover] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState({ x: 0, y: 0 });
    const popoverRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setShowPopover(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    let [filterValues, setFilterValues] = useState([]);
    const [searchText, setSearchText] = useState('');
    useEffect(() => {
        if (showPopover) {
            setSearchText('');
        }
    }, [showPopover]);

    // const handleHeaderMenuClick = (event, position) => {


    //     debugger
    //     const { x, y } = position;
    //     if (newDataColumns[event]) {
    //         let colName = newDataColumns[event]?.ColName?.toUpperCase();
    //         setSelectedColumn({ x, y: y + 30, colName, DataType: newDataColumns[event]?.dataType });
    //         setShowPopover(true);

    //         const colorCol = `${colName}_COLOR`;
    //         if (filterdata.some(d => d.hasOwnProperty(colorCol))) {
    //             let colorValues = Array.from(new Set([...filterdata?.map(x => x[colorCol])])).filter(x => x)
    //             colorValues = colorValues.sort((a, b) =>
    //                 a?.toLowerCase() == 'white' ? 1 : b?.toLowerCase() == 'white' ? -1 : 0
    //             );
    //             setfilterColors(colorValues);
    //         } else {
    //             setfilterColors([]);
    //         }

    //         let values = [];

    //         if (
    //             selectedFilters?.[colName]?.values && selectedFilters[colName].values?.length > 0
    //         ) {
    //             values = Array.from(
    //                 new Set(
    //                     data?.map(item => item[colName])?.filter(x => x !== null && x !== '')
    //                 )
    //             );
    //         } else {
    //             values = Array.from(
    //                 new Set(
    //                     filterdata?.map(item => item[colName])?.filter(x => x !== null && x !== '')
    //                 )
    //             );
    //         }

    //         // ✅ APPLY FORMAT AFTER VALUES CREATED
    //         if (newDataColumns[event]?.dataType?.toLowerCase() === "date") {
    //             values = values.map(val => val ? moment(val).format("DD-MM-YYYY") : val);
    //         }

    //         if (values?.length > 0 && typeof values[0] === 'string') {
    //             values = ['SelectALL', ...values];
    //             values = ['Blank', ...values];
    //             values = ['NotBlank', ...values];
    //         }
    //         if (values?.length > 0 && typeof values[0] === 'number') {
    //             values = ['SelectALL', ...values];
    //             values = [0, ...values];
    //             values = ['Blank', ...values];
    //             values = ['NotBlank', ...values];
    //         }
    //         if (values?.length > 0 && typeof values[0] === 'boolean') { 
    //             values = values.map(x => ({
    //                 label: x ? "True" : "False",
    //                 value: x
    //             }));
    //             values = [
    //                 { label: "SelectALL", value: "SelectALL" },
    //                 ...values
    //             ];
    //         }

    //         setFilterValues(values);
    //         filterValues = values;
    //     }
    // };


    const handleHeaderMenuClick = (event, position) => {

        debugger

        const { x, y } = position;

        if (newDataColumns[event]) {

            let colName = newDataColumns[event]?.ColName?.toUpperCase();

            setSelectedColumn({
                x,
                y: y + 30,
                colName,
                DataType: newDataColumns[event]?.dataType
            });

            setShowPopover(true);

            const colorCol = `${colName}_COLOR`;

            if (filterdata.some(d => d.hasOwnProperty(colorCol))) {

                let colorValues = Array.from(
                    new Set([...filterdata?.map(x => x[colorCol])])
                ).filter(x => x);

                colorValues = colorValues.sort((a, b) =>
                    a?.toLowerCase() === 'white'
                        ? 1
                        : b?.toLowerCase() === 'white'
                            ? -1
                            : 0
                );

                setfilterColors(colorValues);

            } else {

                setfilterColors([]);
            }

            let values = [];

            // Get values
            if (
                selectedFilters?.[colName]?.values &&
                selectedFilters[colName].values?.length > 0
            ) {

                values = Array.from(
                    new Set(
                        data
                            ?.map(item => item[colName])
                            ?.filter(x => x !== null && x !== '')
                    )
                );

            } else {

                values = Array.from(
                    new Set(
                        filterdata
                            ?.map(item => item[colName])
                            ?.filter(x => x !== null && x !== '')
                    )
                );
            }

            // Date format
            if (
                newDataColumns[event]?.dataType?.toLowerCase() === "date"
            ) {

                values = values.map(val =>
                    val ? moment(val).format("DD-MM-YYYY") : val
                );
            }

            // STRING
            if (values?.length > 0 && typeof values[0] === 'string') {

                values = [
                    'SelectALL',
                    'Blank',
                    'NotBlank',
                    ...values
                ];
            }

            // NUMBER
            else if (values?.length > 0 && typeof values[0] === 'number') {

                values = [
                    'SelectALL',
                    'Blank',
                    'NotBlank',
                    0,
                    ...values
                ];
            }

            // BOOLEAN
            else if (values?.length > 0 && typeof values[0] === 'boolean') {

                values = values.map(x => ({
                    label: x ? "True" : "False",
                    value: x
                }));

                values = [
                    {
                        label: "SelectALL",
                        value: "SelectALL"
                    },
                    ...values
                ];
            }

            setFilterValues(values);
            filterValues = values;
        }
    };
    const handleCellDoubleClick = ([col, row]) => {
        let NewColumn = columns.filter(x => x.IsHide == false)
        const rowData = filterdata[row];
        const columnName = NewColumn[col]?.field;
        if (onCellDoubleClicked) {
            onCellDoubleClicked(rowData, columnName);
        }
    };


    function FormulaRowAdd() {
        if (FormulaColumn?.length === 0) {
            const FormulaColumn = columns && columns?.filter(obj => obj.Formula !== undefined && obj.Formula !== "");
            setFormulaColumn(FormulaColumn)
        }
        if (FormulaColumn?.length > 0) {
            const totalRow = {};

            const Actualfilterdata = filterdata?.filter(row => row.RowID !== "Total");
            FormulaColumn.forEach(column => {
                const columnName = column.ColName;
                const Formula = column.Formula;

                const DataType = column.dataType;

                if (Formula && Formula?.toLowerCase() === "total") {
                    totalRow[columnName] = "Total";
                }
                else if (Formula && Formula?.toLowerCase() === "total") {
                    const sum = Actualfilterdata.reduce((total, row) => total + (row[columnName] || 0), 0);
                    if (column.dataType?.toLowerCase() === 'number') {
                        totalRow[columnName] = (sum).toFixed(0);
                    }
                    else {
                        totalRow[columnName] = sum.toString();
                    }
                } else if (Formula && Formula?.toLowerCase() === "count") {
                    // const count = Actualfilterdata.reduce((total, row) => Number(row[columnName]) ? total + 1 : total, 0);

                    // if (column.dataType?.toLowerCase() === 'number') {
                    //     totalRow[columnName] = (count).toFixed(0);
                    // }
                    // else {
                    //     totalRow[columnName] = count.toString();
                    // }

                    const count = Actualfilterdata.reduce((total, row) =>
                        row[columnName] !== undefined && row[columnName] !== null && row[columnName] !== '' ? total + 1 : total, 0
                    );

                    totalRow[columnName] = count.toString();

                } else if (Formula && Formula?.toLowerCase() === "sum") {
                    let totalSum = 0;
                    Actualfilterdata.forEach((row) => totalSum = totalSum + Number(row[columnName]) ?? 0);
                    totalSum = Number(totalSum).toFixed(2)
                    if (column.dataType?.toLowerCase() === 'number') {
                        totalRow[columnName] = Number(totalSum).toFixed(2);
                    }
                    else {
                        totalRow[columnName] = totalSum.toString();
                    }
                } else if (Formula && Formula?.toLowerCase() === "sumint") {
                    let totalSum = 0;
                    Actualfilterdata.forEach((row) => totalSum = totalSum + Number(row[columnName]) ?? 0);
                    totalSum = Number(totalSum).toFixed(0)
                    if (column.dataType?.toLowerCase() === 'number') {
                        totalRow[columnName] = Number(totalSum).toFixed(0);
                    }
                    else {
                        totalRow[columnName] = totalSum.toString();
                    }
                }
                else if (Formula && Formula?.toLowerCase()?.includes("=") === true) {

                    let Formulaname = Formula?.split("=")[0]
                    let Formulacondition = Formula?.split("=")[1]
                    let formulaFields = Formulacondition?.split(",")

                    if (Formulaname?.toLowerCase() === "avg") {

                        const sum = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[0]] * row[formulaFields[1]] || 0), 0);
                        const field2 = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[1]] || 0), 0);

                        if (column.dataType?.toLowerCase() === 'number') {
                            totalRow[columnName] = (sum / field2).toFixed(2);
                        }
                        else {
                            // totalRow[columnName] = count.toString();
                        }
                    }
                    else if (Formulaname?.toLowerCase() === "avgint") {
                        const sum = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[0]] * row[formulaFields[1]] || 0), 0);
                        const field2 = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[1]] || 0), 0);

                        if (column.dataType?.toLowerCase() === 'number') {
                            totalRow[columnName] = (sum / field2).toFixed(0);
                        }
                        else {
                            // totalRow[columnName] = count.toString();
                        }
                    }
                    else if (Formulaname?.toLowerCase() === "dis") {
                        const ORATE_AMT = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[0]] * row[formulaFields[2]] || 0), 0);
                        const RATE_AMT = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[1]] * row[formulaFields[2]] || 0), 0);
                        const I_CARAT = Actualfilterdata.reduce((total, row) => total + (row[formulaFields[2]] || 0), 0);

                        if (column.dataType?.toLowerCase() === 'number') {
                            totalRow[columnName] = ORATE_AMT > 0 ? (((ORATE_AMT - RATE_AMT) / ORATE_AMT) * 100.0).toFixed(2) : 0.00;
                        }
                        else {
                            // totalRow[columnName] = count.toString();
                        }
                    }
                }
            });
            totalRow["RowID"] = "Total";
            setfilterdata([...Actualfilterdata, totalRow]);
            setSummaryRowCount(1)
        }
    }

    function formatNumber(numberString, format) {
        if (format === undefined || format === null) {
            return numberString
        }
        if (!numberString) {
            return '';
        }
        const number = parseFloat(numberString);
        if (isNaN(number)) {
            return '';
        }
        const decimalPlaces = format?.split('.')[1] ? format?.split('.')[1]?.length : 0;
        const formattedNumber = number.toLocaleString(undefined, {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });
        return formattedNumber;
    }

    const onItemHovered = React.useCallback(args => {
        //
        const [_, row] = args.location
        setHoverRow(args.kind !== "cell" ? undefined : row)
    }, [])

    const getRowThemeOverride = React.useCallback(
        row => {
            if (row == hoverRow) return {
                bgCell: 'lightgray'
            }
            if (!(row % 2 === 0)) {
                if (row == hoverRow) return {
                    bgCell: 'lightgray'
                }
                return {
                    bgCell: "#e0f0ff88",
                }
            }
        },
        [hoverRow]
    )
    function findValueByKey(obj, key) {
        const lowerCaseKey = key.toLowerCase(); // Convert key to lowercase
        for (const objKey in obj) {
            if (objKey.toLowerCase() === lowerCaseKey) { // Convert object key to lowercase for comparison
                return obj[objKey];
            }
        }
        return undefined; // Key not found
    }
    const getContent = useCallback(
        (cell) => {
            try {

                const [col, row] = cell;
                const dataRow = filterdata[row];
                // const dataRow = data_Man[row]; 
                let d = ""
                let ColKey = ""
                if (newDataColumns?.length === 0) {
                    d = ""
                }
                else {

                    d = dataRow && dataRow[newDataColumns[col].id?.toUpperCase()];  //JP

                    if (ViewparaName && ViewparaName?.toLowerCase() == "columnconfig") //Jaydeep
                    {
                        d = dataRow && dataRow[newDataColumns[col].id];
                    }

                    ColKey = newDataColumns[col].ColName;
                    // d = dataRow[ColKey];
                    // d=findValueByKey(dataRow,ColKey)
                }
                if (d === undefined || d === null) {
                    d = ""
                }

                let { dataType, DispFormat, contentAlign, BackColor, ForeColor, IsLock, DispFormate, ColName } = newDataColumns[col];

                if (dataType == null || dataType == undefined) {
                    dataType = "";
                }

                if (BackColor == null || BackColor == undefined) {
                    BackColor = "";
                }
                if (ForeColor == null || ForeColor == undefined) {
                    ForeColor = "";
                }

                if (dataType === "bubble" && d === "") {
                    dataType = ""
                }
                if (dataRow && dataRow["RowID"]?.toLowerCase() === "total") {
                    BackColor = ""
                    ForeColor = ""
                    IsLock = true
                    if ((dataType?.toLowerCase() === "boolean" || dataType?.toLowerCase() === "linkbutton") && d === "") {
                        dataType = ""
                        BackColor = ""
                        ForeColor = ""
                        d = ""
                    }
                }

                let theme = getCellTheme && dataRow && getCellTheme(dataRow, ColKey);
                // if (theme && getCellTheme && BackColor !== "") {
                //     theme.bgCell = BackColor;
                // }
                // if (theme && getCellTheme && ForeColor !== "") {
                //     theme.textDark = ForeColor;
                // }


                if (theme && getCellTheme) {
                    if (BackColor !== "") {
                        theme.bgCell = BackColor;
                    }
                    if (ForeColor !== "") {
                        theme.textDark = ForeColor;
                    }
                }
                else if (!theme) {
                    if (!theme) {
                        theme = {};
                    }
                    if (BackColor !== "") {
                        theme.bgCell = BackColor;
                    }
                    if (ForeColor !== "") {
                        theme.textDark = ForeColor;
                    }
                }
                // theme.baseFontStyle="900"
                if (dataType?.toLowerCase() === "number") {
                    let displayValue = '';
                    if (DispFormate) {
                        if (DispFormate == '0') {
                            displayValue = Number(d).toFixed(0)
                        }
                        else if (DispFormate == '0.0') {
                            displayValue = Number(d).toFixed(1)
                        }
                        else if (DispFormate == '0.00') {
                            displayValue = Number(d).toFixed(2)
                        }
                        else if (DispFormate == '0.000') {
                            displayValue = Number(d).toFixed(3)
                        }
                        else if (DispFormate?.toLowerCase() == 'ind') {
                            displayValue = new Intl.NumberFormat('en-IN').format(Number(d));
                        }
                        else {
                            displayValue = formatNumber(d, DispFormat).toString()
                        }
                    }
                    else {
                        displayValue = formatNumber(d, DispFormat).toString()
                    }
                    return {
                        allowOverlay: !IsLock,
                        kind: GridCellKind.Number,
                        readonly: IsLock,
                        hasMenu: false,
                        data: d,
                        displayData: displayValue,
                        // displayData: d.toString(),
                        contentAlign: contentAlign,
                        themeOverride: theme,
                        hoverEffect: true,
                        // themeOverride: {
                        //     textDark: "black",      //text Color                                          
                        //     baseFontStyle: "600 13px"
                        //   }
                    };
                }

                else if (dataType?.toLowerCase() === "text") {
                    return {
                        allowOverlay: !IsLock,
                        kind: GridCellKind.Text,
                        readonly: IsLock,
                        hasMenu: false,
                        data: d,
                        displayData: d.toString(),
                        contentAlign: contentAlign,
                        themeOverride: theme,
                        // hoverEffect: true
                    };
                }

                else if (dataType?.toLowerCase() === "boolean" && dataRow && dataRow["RowID"]?.toLowerCase() != "total") {
                    if (d === "" || d === undefined || d === null) {
                        d = false
                    }
                    return {
                        allowOverlay: !IsLock,
                        kind: GridCellKind.Boolean,
                        readonly: IsLock,
                        data: d,
                        displayData: d
                    };
                }

                else if (dataType?.toLowerCase() === "img" && dataRow && dataRow["RowID"]?.toLowerCase() != "total") {
                    let icon = '';
                    if (ColName == 'HOLDPKT' && dataRow["RowID"]?.toLowerCase() != "total" && dataRow["HOLDPKT"] == 1) {
                        icon = holdImage;
                    } else if (ColName == 'CONFIRMPKT' && dataRow["RowID"]?.toLowerCase() != "total" && dataRow["CONFIRMPKT"] == 1) {
                        icon = confirmImage;
                    } else if (ColName == 'ISACTIVE' && dataRow["RowID"]?.toLowerCase() != "total" && dataRow["ISACTIVE"] == 1) {
                        icon = ChekSvg;
                    } else if (ColName == 'DOCUMENT' && dataRow["DOCUMENT"]?.toLowerCase() != 'total') {
                        icon = pdfImage;
                    } else if (ColName == 'RESETPASS') {
                        icon = passResetpng;
                    }

                    return {
                        allowOverlay: !IsLock,
                        kind: GridCellKind.Image,
                        readonly: IsLock,
                        hasMenu: false,
                        data: [icon],
                        displayData: [icon],
                    }
                }

                else if (dataType?.toLowerCase() === "url" && dataRow && dataRow["RowID"]?.toLowerCase() != "total") {
                    let icon = '';
                    if (ColName == 'PHOTOLINK' && dataRow["RowID"]?.toLowerCase() != "total" && dataRow["PHOTOLINK"] != null) {
                        icon = '📸';
                    } else if ((ColName == 'VIDEOLINK1' && dataRow["VIDEOLINK1"] != null) || ((ColName == 'VIDEOLINK2' && dataRow["VIDEOLINK2"] != null))) {
                        icon = '▶️';
                    } else if ((ColName == 'PDFLINK' && dataRow["PDFLINK"] != null)) {
                        icon = '📕';
                    } else {
                        icon = '';
                    }
                    return {
                        kind: GridCellKind.Uri,
                        displayData: ColName.toUpperCase().includes('LINK') ? icon : d,
                        data: d,
                        hoverEffect: true,
                        allowOverlay: !IsLock,
                        readonly: IsLock,
                        onClickUri: a => {
                            if (ColName == 'CERTNO') {
                                window.open(dataRow.REPORTLINK, "_blank");
                                a.preventDefault();
                            } else {
                                window.open(d, "_blank");
                                a.preventDefault();
                            }
                        },
                    };
                }
                else if (dataType?.toLowerCase() === "star1") {
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: false,
                        readonly: true,
                        copyData: "4 out of 5",
                        hasMenu: false,
                        data: {
                            kind: "star-cell",
                            label: "Test",
                            rating: 1,
                        },
                    };
                }
                else if (dataType?.toLowerCase() === "drilldown") {
                    return {
                        kind: GridCellKind.Drilldown,
                        data: [
                            {
                                text: "Test",
                                img: "https://allthatsinteresting.com/wordpress/wp-content/uploads/2012/06/iconic-photos-1950-einstein.jpg",
                            },
                            { text: "No Image" },
                        ],
                        allowOverlay: false,
                        readonly: true
                    };
                }
                else if (dataType?.toLowerCase() === "button" && ActionButton && ActionButton(dataRow, ColKey)) {
                    if (ColKey?.toLowerCase() === "edit" && d !== "edit") {
                        return {
                            kind: GridCellKind.Text,
                            allowOverlay: false,
                            readonly: true,
                            hasMenu: false,
                            displayData: d,
                            data: d,
                            // themeOverride: theme
                        };
                    }
                    else if (d?.toLowerCase() === "hide" || dataRow["RowID"]?.toLowerCase() === "total") {
                        return {
                            kind: GridCellKind.Custom,
                            allowOverlay: false,
                            readonly: true,
                            hasMenu: false,
                            data: "",
                            // themeOverride: theme
                        };
                    }
                    else {
                        return {
                            kind: GridCellKind.Custom,
                            allowOverlay: false,
                            readonly: true,
                            hasMenu: false,
                            data: ActionButton(dataRow, ColKey),
                            themeOverride: {
                                baseFontStyle: "700 13px"
                            }
                        };
                    }
                }
                else if (dataType?.toLowerCase() === "dropdown1") {
                    const v = dataRow["DISC"]
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        readonly: false,
                        hasMenu: false,
                        data: {
                            kind: "range-cell",
                            min: 0,
                            max: 150,
                            value: v,
                            step: 0.10,
                            // label: `${Math.round(v * 100)}%`,
                            label: `${v} %`,
                            measureLabel: "100%"
                        }
                    };
                }
                else if (dataType === "dropdown") { // Add this block for dropdown
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: !IsLock,
                        readonly: IsLock,
                        hasMenu: false,
                        data: {
                            kind: "dropdown-cell",
                            allowedValues: ["A", "B", "C"], // Define your options here
                            value: "A",
                        },
                        contentAlign: contentAlign,
                        themeOverride: {
                            bgCell: '#FFFF',
                            textDark: '#0000' || "",
                        },
                    };
                }
                else if (dataType?.toLowerCase() === "date") {
                    let date = new Date(dataRow[ColKey])
                    if (date.getFullYear() > 2000) {
                        date = moment(date).format('DD/MM/YYYY')
                    } else {
                        date = ''
                    }
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        copyData: "4",
                        readonly: true,
                        data: {
                            kind: "date-picker-cell",
                            date: date ? new Date(dataRow[ColKey]) : new Date(),
                            displayDate: date,
                            format: "date"
                        }
                    };
                }
                else if (dataType?.toLowerCase() === "demo11") {
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        copyData: "4",
                        readonly: false,
                        data: {
                            kind: "article-cell",
                            markdown: "## This is a test"
                        }
                    };
                }

                else if (dataType?.toLowerCase() === "demo") {
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        copyData: "4",
                        readonly: false,

                        data: {
                            kind: "tags-cell",
                            possibleTags: possibleTags,
                            tags: ([
                                possibleTags[1].tag,
                            ])
                        }
                    };
                }



                else if (dataType?.toLowerCase() === "demoDrop") {


                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        copyData: "4",
                        readonly: false,
                        data: {
                            kind: "dropdown-cell",
                            allowedValues: [
                                null,
                                "Good",
                                "Better",
                                {
                                    value: "best",
                                    label: "Best"
                                }
                            ],
                            value: "Good"
                        }
                    };
                }

                else if (dataType?.toLowerCase() === "linkbutton") {
                    if (d === "" || ActionButton(dataRow, ColKey) === undefined) {
                        return {
                            kind: GridCellKind.Text,
                            allowOverlay: false,
                            readonly: true,
                            displayData: "",
                            data: "",
                            hasMenu: false
                        }
                    }
                    else {
                        return {
                            kind: GridCellKind.Custom,
                            allowOverlay: false,
                            readonly: true,
                            hasMenu: false,
                            data: ActionButton(dataRow, ColKey),
                        };
                    }
                }
                else if (dataType?.toLowerCase() === "image") {

                    return {
                        kind: GridCellKind.Image,
                        data: [
                            "https://i.imgur.com/5J0BftG.jpg",
                            "https://i.imgur.com/5J0BftG.jpg",
                            "https://i.imgur.com/5J0BftG.jpg",
                            "https://i.imgur.com/5J0BftG.jpg",
                        ],
                        onClick: () => {
                            window.open("https://transform.tools/typescript-to-javascript", "_blank");
                        },
                        onClickUri: () => {
                            window.open("https://transform.tools/typescript-to-javascript", "_blank");
                        },
                        allowOverlay: false,
                        readonly: false,


                    };
                } else if (dataType?.toLowerCase() === "bubble") {
                    return {
                        kind: GridCellKind.Bubble,
                        data: d.split(","),
                        allowOverlay: false,
                        readonly: false,
                        contentAlign: contentAlign

                    };
                } else if (dataType?.toLowerCase() === "dropdown111") {
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        copyData: 4,
                        readonly: IsLock,
                        hasMenu: false,
                        data: {
                            kind: "dropdown-cell",
                            allowedValues: [
                                null,
                                "Good",
                                "Better",
                                {
                                    value: "best",
                                    label: "Best"
                                }
                            ],
                            value: "Good"
                        }
                    };
                } else if (dataType?.toLowerCase() === "datepicker") {
                    return {
                        kind: GridCellKind.Custom,
                        allowOverlay: true,
                        copyData: "4",
                        readonly: IsLock,
                        hasMenu: false,
                        data: {
                            kind: "date-picker-cell",
                            date: new Date(),
                            displayDate: new Date().toISOString(),
                            format: "date"
                        }
                    };
                } else {
                    return {
                        kind: GridCellKind.Text,
                        allowOverlay: true,
                        readonly: false,
                        displayData: d,
                        data: d,
                        hasMenu: false,
                        contentAlign: contentAlign,
                        themeOverride: theme,
                        // hoverEffect: hoverEffect,
                        // allowWrapping: true,
                        hoverEffectTheme: {
                            bgColor: "red",
                            fullSize: true,
                        },
                    };
                }
            } catch (error) {
            }
        },
        [filterdata]
    );

    const onCellEdited = useCallback((cell, newValue) => {
        const jsonString = filterdata && JSON.stringify(filterdata);
        let Actualfilterdata = JSON.parse(jsonString)

        // let Actualfilterdata = filterdata.filter(row => row.RowID !== "Total");
        if (newValue.kind === GridCellKind.Custom) {
            return
        }
        const [col, row] = cell
        let colkey = newDataColumns[col].ColName;
        let modifyRow = { ...filterdata[row], [colkey]: newValue.data, "EDIT": "edit" }

        if (JSON.stringify(filterdata[row]) !== JSON.stringify(modifyRow)) {
            let modifyArr = { ...Modify_data, [row]: modifyRow };
            Modify_data = modifyArr;
            setModify_data(modifyArr);
        }
        else {
            delete Modify_data[row];
            // Modify_data = Modify_data;
            setModify_data(Modify_data);
        }
        Actualfilterdata[row][colkey] = newValue.data
        Actualfilterdata[row]["EDIT"] = "edit"
        GetselectedRow && GetselectedRow(Object.values(Modify_data), modifyRow, colkey)
        filterdata = [...Actualfilterdata];
        setfilterdata(filterdata);
        // sortFilterData();

    }, [newDataColumns, data, Modify_data, filterdata])

    const onColumnResize = React.useCallback((column, newSize) => {
        //
        const index = newDataColumns && newDataColumns.findIndex(ci => ci.title === column.title)
        const newArray = [...newDataColumns]
        newArray.splice(index, 1, {
            ...newDataColumns[index],
            width: newSize
        })
        setnewDataColumns(newArray);
    }, [newDataColumns])

    const onColMoved = useCallback((startIndex, endIndex) => {
        let newCols = JSON.parse(JSON.stringify(newDataColumns))
        let rowToMove = newCols[startIndex];
        newCols.splice(startIndex, 1);

        newCols.splice(endIndex, 0, rowToMove);
        newCols = newCols?.filter((x, i) => x.Ord = i + 1)
        setnewDataColumns([...newCols])
    }, [newDataColumns])

    useEventListener(
        "keydown",
        React.useCallback(event => {
            if ((event.ctrlKey || event.metaKey) && event.code === "KeyF") {
                setShowSearch(cv => !cv)
                event.stopPropagation()
                event.preventDefault()
            }
        }, []),
        window,
        false,
        true
    )
    const SearchFilterData = (value) => {
        value = value?.toLowerCase();
        if (value !== "") {
            const newData = data && data?.filter((person) => {
                const anyFieldMatches = Object.values(person).some((personValue) => {
                    if (typeof personValue === 'string') {
                        return personValue?.toLowerCase().includes(value);
                    }
                    return false;
                });
                return anyFieldMatches;
            });

            setfilterdata(newData);
            filterdata = newData;
            setNumRows(newData.length)
        }
        else {
            setfilterdata(data);
            filterdata = data;
            setNumRows(data.length)
        }
        FormulaRowAdd()
    };
    const searchResults = React.useMemo(() => {
        //
        SearchFilterData(searchValue)
    }, [searchValue.length])

    useEffect(() => {
        if (sortColumn.Index != -1) {
            sortFilterData();
        }
    }, [sortColumn])

    const sortFilterData = () => {

        ///// Sorting nu change kryu che Khushali a -------20-12-25
        const colIndex = sortColumn.Index;
        if (colIndex === -1 || !filterdata?.length) return;

        const colName = newDataColumns[colIndex].ColName?.toUpperCase();
        const dataType = newDataColumns[colIndex]?.dataType?.toLowerCase();

        const dataRows = filterdata.filter(r => r.RowID?.toLowerCase() !== "total");
        const summaryRow = filterdata.filter(r => r.RowID?.toLowerCase() === "total");

        const descStringSort = (a, b) => {
            const A = a[colName] || "";
            const B = b[colName] || "";
            return B.localeCompare(A, undefined, { numeric: true, sensitivity: "base" })
                || B.length - A.length;
        };

        const ascStringSort = (a, b) => {
            const A = a[colName] || "";
            const B = b[colName] || "";
            return A.localeCompare(B, undefined, { numeric: true, sensitivity: "base" })
                || A.length - B.length;
        };

        let sortedData;

        if (sortColumn.Sort === "ASC") {
            if (dataType === "number") {
                sortedData = dataRows.sort((a, b) => a[colName] - b[colName]);
            } else if (dataType === "boolean") {
                sortedData = dataRows.sort((a, b) => a[colName] === b[colName] ? 0 : a[colName] ? 1 : -1);
            } else {
                sortedData = dataRows.sort(ascStringSort);
            }
        } else {
            if (dataType === "number") {
                sortedData = dataRows.sort((a, b) => b[colName] - a[colName]);
            } else if (dataType === "boolean") {
                sortedData = dataRows.sort((a, b) => a[colName] === b[colName] ? 0 : a[colName] ? -1 : 1);
            } else {
                sortedData = dataRows.sort(descStringSort);
            }
        }

        setnewDataColumns(cols =>
            cols.map((c, i) =>
                i === colIndex ? { ...c, Sort: sortColumn.Sort === "ASC" ? "DESC" : "ASC" } : c
            )
        );

        setfilterdata([...sortedData, ...summaryRow]);
    };



    function sortData(colIndex) {

        setsortColumn({ Index: colIndex, Sort: newDataColumns[colIndex].Sort == "DESC" ? "DESC" : "ASC" })
        sortColumn = { Index: colIndex, Sort: newDataColumns[colIndex].Sort == "DESC" ? "DESC" : "ASC" };
        // const filterdata_tmp = filterdata?.filter(row => row.RowID?.toLowerCase() !== "total");
        // const SummaryField = filterdata?.filter(row => row.RowID?.toLowerCase() === "total");
        // let NewSort = undefined
        // if (newDataColumns[colIndex].Sort === "ASC") {
        //     if (newDataColumns[colIndex].dataType?.toLowerCase() === "number") {
        //         NewSort = filterdata_tmp.sort((a, b) => a[newDataColumns[colIndex].ColName] - b[newDataColumns[colIndex].ColName]);
        //     }
        //     else {
        //         NewSort = filterdata_tmp.sort((a, b) => a[newDataColumns[colIndex].ColName]?.localeCompare(b[newDataColumns[colIndex].ColName]));
        //     }
        //     setnewDataColumns(prevColumns => {
        //         const updatedColumns = prevColumns.map((col, index) =>
        //             index === colIndex
        //                 ? { ...col, Sort: "DESC" }
        //                 : col
        //         );
        //         return updatedColumns;
        //     });
        // }
        // else {
        //     if (newDataColumns[colIndex].dataType?.toLowerCase() === "number") {
        //         NewSort = filterdata_tmp.sort((a, b) => b[newDataColumns[colIndex].ColName] - a[newDataColumns[colIndex].ColName]);
        //     }
        //     else {
        //         NewSort = filterdata_tmp.sort((a, b) => b[newDataColumns[colIndex].ColName]?.localeCompare(a[newDataColumns[colIndex].ColName]));
        //     }
        //     setnewDataColumns(prevColumns => {
        //         const updatedColumns = prevColumns.map((col, index) =>
        //             index === colIndex
        //                 ? { ...col, Sort: "ASC" }
        //                 : col
        //         );
        //         return updatedColumns;
        //     });
        // }
        // setfilterdata([...NewSort, ...SummaryField])
    }

    // const [numRows, setNumRows] = React.useState(50)
    const onRowAppended = React.useCallback(() => {
        let newData = {}

        newDataColumns.forEach(index => {
            if (index.IsUpdate === true) {
                if (index.dataType?.toLowerCase() === "number") {
                    newData[index.id] = 0
                }
                else if (index.dataType?.toLowerCase() === "boolean") {
                    newData[index.id] = false
                }
                else {
                    newData[index.id] = ""
                }
            }
        })

        // setData([...data, newData]) 
        setfilterdata([...filterdata, newData]);
        setModify_data([...filterdata, newData])

    }, [data, newDataColumns, filterdata])

    function ViewparaClick() {
        setVisible(true)
    }

    const ViewparaheaderElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            {/* <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" /> */}
            <span className="viewparaHeading">Column Configuration</span>
        </div>
    );

    const ExcelGen = () => {
        ExcelGenerate(ExcelGet, filterdata, Setting); // Call ExcelGen function with the data to export
    };

    const saveColumnConfig = () => {
        const ObjJson = {
            jsonObj1: newDataColumns,
            SPName: "API_ColumnConfigBtnSave"
        };
        dispatch(updateColumnConfig(ObjJson))
    }

    const rightElement = () => {

        const isAllSelected =
            Selection === true &&
            filterdata
                ?.filter(x => x?.RowID?.toLowerCase() !== "total")
                ?.every(x => x?.[SelectionColumn] === true);

        const handleSelection = (checked) => {

            setIsSelectAllChecked(checked);

            const updatedData = filterdata?.map(row => {

                if (row?.RowID?.toLowerCase() === "total") {
                    return row;
                }

                return {
                    ...row,
                    [SelectionColumn]: checked
                };
            });

            setfilterdata(updatedData);

            if (GetselectedRow) {
                GetselectedRow(updatedData);
            }
        };

        return (
            <>
                <div className="d-flex align-items-center">

                    {Selection === true && (
                        <div className="d-flex align-items-center me-2">

                            <input
                                type="checkbox"
                                checked={isSelectAllChecked}
                                onChange={(e) => handleSelection(e.target.checked)}
                                style={{
                                    cursor: "pointer",
                                    width: "16px",
                                    height: "20px"
                                }}
                            />
                        </div>
                    )}

                    <div className='px-2'>
                        <img
                            src={RemoveFilter}
                            style={{
                                cursor: "pointer",
                                height: "22px",
                                width: "22px"
                            }}
                            onClick={() => clearAllFilters()}
                            title="Clear Filters"
                        />
                    </div>

                    <div>
                        {ExcelGet !== "" && ExcelGet !== undefined &&
                            <img
                                src={saveIcon}
                                className='me-2'
                                style={{
                                    cursor: "pointer",
                                    height: '20px',
                                    width: '20px'
                                }}
                                onClick={() => saveColumnConfig()}
                                title="Width & Order Set"
                            />
                        }
                    </div>

                    <div>
                        {ViewparaName !== "" && ViewparaName !== undefined &&
                            <img
                                src={settingicon}
                                style={{ cursor: "pointer" }}
                                onClick={() => ViewparaClick()}
                                title="Get Viewpara"
                            />
                        }
                    </div>

                    <div className='px-2'>
                        {ExcelGet !== "" && ExcelGet !== undefined &&
                            <img
                                src={excelIcon}
                                style={{ cursor: "pointer" }}
                                onClick={() => ExcelGen()}
                                title="Excel Export"
                            />
                        }
                    </div>

                    <div>
                        {ExcelGet !== "" && ExcelGet !== undefined &&
                            <div onClick={() => setsowChartPopup(true)}>
                                <HiChartSquareBar
                                    size={28}
                                    style={{ cursor: "pointer" }}
                                    title="Chart"
                                />
                            </div>
                        }
                    </div>

                </div>
            </>
        );
    };
    useEffect(() => {

        if (!searchText) {
            return;
        }

        const staticValues = ["SelectALL"];
        const searchList = searchText
            ?.split(/[\s,]+/)
            ?.map(s => s.trim()?.toLowerCase())
            ?.filter(Boolean);



        let values = []

        values = Array.from(
            new Set(
                data?.map(item => item[selectedColumn.colName])?.filter(x => x !== null && x !== '')
            )
        );

        if (values.length > 0 && typeof values[0] === 'string') {
            values = ['SelectALL', ...values];
            values = ['Blank', ...values];
            values = ['NotBlank', ...values];
        }
        if (values.length > 0 && typeof values[0] === 'number') {
            values = ['SelectALL', ...values];
            values = [0, ...values];
            values = ['Blank', ...values];
            values = ['NotBlank', ...values];
        }

        const matchedValues = values?.filter(item =>
            searchList.some(searchTerm =>
                String(item)?.toLowerCase()?.includes(searchTerm)
            )
        );


        const mergedValues = [...staticValues, ...matchedValues];
        setFilterValues(mergedValues);

    }, [searchText]);


    const selectFilter = (e, colName, type, dataType) => {
        setSelectedFilters(prev => {
            const prevFilters = prev[colName] || { colors: [], values: [] };
            const isSelectAll = e.target.value === 'SelectALL';

            if (isSelectAll) {
                let updatedList = [];

                if (e.target.checked) {
                    // ✅ Select 'SelectALL' + all others
                    updatedList = filterValues?.map(item =>
                        dataType?.toLowerCase() === 'number' && item !== 'SelectALL'
                            ? Number(item)
                            : item
                    );
                } else {
                    // ❌ Uncheck all
                    updatedList = [];
                }

                const newFilters = {
                    ...prevFilters,
                    [type]: updatedList
                };

                if (newFilters.colors?.length === 0 && newFilters.values?.length === 0) {
                    const { [colName]: _, ...rest } = prev;
                    return rest;
                }
                return { ...prev, [colName]: newFilters };
            }

            // Normal individual checkbox toggle
            let convertedValue =
                dataType?.toLowerCase() === 'text'
                    ? String(e.target.value)
                    : dataType?.toLowerCase() === 'number'
                        ? Number(e.target.value)
                        : e.target.value;

            let updatedList;
            if (e.target.checked) {
                updatedList = [...prevFilters[type], convertedValue];
            } else {
                updatedList = prevFilters[type]?.filter(x => x !== convertedValue);
            }

            const newFilters = {
                ...prevFilters,
                [type]: updatedList
            };

            if (newFilters.colors?.length === 0 && newFilters.values?.length === 0) {
                const { [colName]: _, ...rest } = prev;
                return rest;
            }

            return { ...prev, [colName]: newFilters };
        });
    };


    const handleConditionChange = () => {

        setSelectedFilters(prev => ({
            ...prev,
            [selectedColumn.colName]: {
                ...prev[selectedColumn.colName],
                condition: {
                    type: conditionType,
                    value: conditionValue
                }
            }
        }));
    };
    const clearFilters = () => {


        const colName = selectedColumn.colName;
        const newFilters = { ...selectedFilters };
        delete newFilters[colName];
        setSelectedFilters(newFilters);
        selectedFilters = newFilters;
        applyFilter()
        setShowPopover(false);
        FormulaRowAdd();
        setIsFilterApply(false);
        if (props.onClearFilter) {
            props.onClearFilter();
        }
    };

    const clearAllFilters = () => {
        setSelectedFilters([]);
        selectedFilters = [];
        applyFilter()
        setShowPopover(false);
        FormulaRowAdd();
        setIsFilterApply(false);
    };
    const applyFilter = () => {

        if (Object.keys(selectedFilters)?.length > 0) {
            // console.log('selectedFilters',selectedFilters,selectedColumn);
            const NData = data.filter(row => {
                return Object.entries(selectedFilters).every(([colName, filterObj]) => {
                    const colorKey = `${colName}_COLOR`;
                    const selectedColors = filterObj.colors || [];
                    const selectedValues = filterObj.values || [];
                    const condition = filterObj.condition;

                    const colorMatch =
                        selectedColors?.length === 0 || selectedColors.includes(row[colorKey]);

                    const valueMatch =
                        selectedValues?.length === 0 ||
                        selectedValues.includes(row[colName]) ||
                        (selectedValues.includes('Blank') && (row[colName] === '' || row[colName] === null || row[colName] === undefined)) ||
                        (selectedValues.includes(0) && (row[colName] === 0)) ||
                        (selectedValues.includes('NotBlank') && !(row[colName] === '' || row[colName] === null || row[colName] === undefined));

                    const conditionMatch = !condition ? true : (() => {
                        const cellValue = Number(row[colName]);
                        const from = Number(condition.value.from);
                        const to = Number(condition.value.to);
                        switch (condition.type) {
                            case 'Equals': return cellValue === from;
                            case 'Does not equal': return cellValue !== from;
                            case 'Greater than': return cellValue > from;
                            case 'Less than': return cellValue < from;
                            case 'Between': return cellValue >= from && cellValue <= to;
                            case 'Blank': return row[colName] === '' || row[colName] == null || row[colName] == 0;
                            case 'Not blank': return row[colName] !== '' && row[colName] != null && row[colName] != 0;
                            default: return true;
                        }
                    })();

                    return colorMatch && valueMatch && conditionMatch;
                });
            });


            setfilterdata(JSON.parse(JSON.stringify(NData)));
            filterdata = JSON.parse(JSON.stringify(NData));
            setIsFilterApply(true);

            if (props.onFilterApply) {
                props.onFilterApply(NData);
            }

        } else {
            setfilterdata(data);
            filterdata = data;
            setIsFilterApply(false);

            if (props.onFilterApply) {
                props.onFilterApply(data);
            }

        }

        setShowPopover(false);
        FormulaRowAdd();
    };


    // useEffect(() => {
    //   let portal =  document.querySelectorAll('#portal')

    //   if(portal.length > 1){
    //     portal[0].remove()
    //   }
    //   return () => {
    //     let portal =  document.querySelectorAll('#portal')
    //     portal.forEach(x => x.remove())
    //     document.getElementById('portalContainer').innerHTML = '<div id="portal" style="position: fixed; left: 0; top: 0; zIndex: 9999;" />'
    //   }
    // }, [])

    const [conditionType, setConditionType] = useState('Equals');
    const [conditionValue, setConditionValue] = useState({ from: '', to: '' });
    return (
        <>
            {
                ViewparaName !== "" && <Dialog visible={visible} className='customDialog' modal={true} header={ViewparaheaderElement} style={{ width: '75vw', backgroundColor: "red" }} onHide={() => setVisible(false)} position=''>
                    <div className='p-2'>
                        <ColumnConfigComp MenuCode={ViewparaName} />
                    </div>
                </Dialog>
            }

            {
                newDataColumns && newDataColumns?.length > 0 && filterdata && filterdata?.length > 0 && <DataEditor
                    customRenderers={allCells}
                    headerHeight={headerHeight ? headerHeight : 30}
                    rowHeight={rowHeight ? rowHeight : 28}
                    onHeaderMenuClick={handleHeaderMenuClick}

                    onCellEdited={onCellEdited}
                    getCellContent={getContent}
                    onCellClicked={handleCellDoubleClick}
                    // data={data}

                    searchResults={searchResults}
                    searchValue={searchValue}
                    onSearchValueChange={setSearchValue}
                    // rows={searchValue.length === 0 ? 10_000 : searchValue.length}
                    columns={newDataColumns}
                    headerIcons={headerIcons}
                    rows={filterdata.length}
                    // rows={numRows}
                    width={"100%"}
                    // rowMarkers={"checkbox"}
                    // rowHeight={25}
                    height={height}
                    onColumnResize={onColumnResize}
                    onColumnMoved={onColMoved}
                    smoothScrollY={true}
                    smoothScrollX={true}

                    // onItemHovered={onItemHovered}

                    // getRowThemeOverride={i => i % 2 === 0 ? undefined : {  //Odd Even row Color karva mate
                    //     bgCell: "#e0f0ff88"
                    //     //   borderColor: "#3f90e0",
                    // }}

                    // getRowThemeOverride={getRowThemeOverride}

                    // getRowThemeOverride={(i) => filterdata[i]?.isTotalRow === true ? { bgCell: "red" } : undefined} // Apply background color for total row
                    // getRowThemeOverride={(i) => filterdata[i]?.RowID === "Total" ? { bgCell: "#fec89a" } : undefined} // Apply background color for total row

                    showSearch={showSearch}


                    // onSearchValueChange={setSearchValue}
                    // onColumnResize={true}



                    onSearchClose={() => {
                        setShowSearch(false);
                        setSearchValue("");
                    }}
                    onHeaderClicked={sortData}

                    // cellActivationBehavior="single-click"
                    verticalBorder={verticalBorder} //VerticalBorder Hide Karva mate
                    freezeColumns={freezeColumns}
                    getCellsForSelection={true}
                    rightElement={rightElement()}
                    rightElementProps={{
                        fill: false,
                        sticky: true
                    }}
                    freezeTrailingRows={AddNewRecord === true ? 1 + SummaryRowCount : SummaryRowCount}
                    onRowAppended={AddNewRecord === true ? onRowAppended : undefined}
                // trailingRowOptions={AddNewRecord && {
                //     hint: "New row...",
                //     sticky: true,
                //     tint: true
                // }}
                />
            }
            {/* <div id="portalContainer">
                <div id="portal" style={{ position: "fixed", left: "0", top: "0", zIndex: "9999" }} />
            </div> */}

            {
                showPopover && (
                    <div
                        ref={popoverRef}
                        className="gridheaderpopover"
                        style={{ left: selectedColumn.x, top: selectedColumn.y }}
                    >
                        <div className="gridheaderpopoverTabsContainer">
                            <Tabs
                                defaultActiveKey={filterColors?.length > 0 ? "Color" : "Data"}
                                id="filter-tabs"
                                className="mb-2"
                                fill
                            >
                                {filterColors?.length > 0 && (
                                    <Tab eventKey="Color" title="Color">
                                        <div className="d-flex align-items-center mb-2">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm me-2"
                                                placeholder="Search..."
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                            />
                                        </div>
                                        {
                                            filterColors
                                                ?.filter(color => color?.toLowerCase()?.includes(searchText?.toLowerCase()))
                                                ?.map((colorName, i) => (
                                                    <div className="d-flex align-items-center mb-2" key={i}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            value={colorName}
                                                            checked={(selectedFilters[selectedColumn.colName]?.colors || []).includes(colorName)}
                                                            onChange={(e) => selectFilter(e, selectedColumn.colName, "colors")}
                                                        />
                                                        <div
                                                            className="ms-2"
                                                            style={{
                                                                backgroundColor: colorName,
                                                                height: '20px',
                                                                width: '20px',
                                                                borderRadius: '4px',
                                                                border: colorName?.toLowerCase() === 'white' ? '1px solid #ccc' : '1px solid #999',
                                                            }}
                                                        />
                                                        <span className="ms-2">{colorName}</span>
                                                    </div>
                                                ))
                                        }
                                    </Tab>
                                )}

                                <Tab eventKey="Data" title="Data">
                                    <div className="d-flex align-items-center mb-2">
                                        <input
                                            type="text"
                                            className="form-control form-control-sm me-2"
                                            placeholder="Search..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                    </div>
                                    {/* {filterValues
                                        ?.map((item, i) => (
                                            <label className="d-flex align-items-center mb-2 w-100" key={i} style={{ cursor: 'pointer' }}>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    value={item}
                                                    onChange={e => {
                                                        const value = selectedColumn.DataType == "Text" ? String(e.target.value) : isNaN(item) ? e.target.value : selectedColumn.DataType == "Url" ? e.target.value : Number(e.target.value);
                                                        selectFilter({ target: { ...e.target, value } }, selectedColumn.colName, 'values', selectedColumn.DataType);
                                                    }}
                                                    checked={selectedFilters[selectedColumn.colName]?.values?.includes(selectedColumn.DataType == "Text" ? String(item) : selectedColumn.DataType == "Url" ? item : Number(item)) || false}
                                                />
                                                <span className="ms-2">{item}</span>
                                            </label>
                                        ))
                                    } */}

                                    {filterValues?.map((item, i) => {

                                        const actualValue =
                                            typeof item === "object"
                                                ? item.value
                                                : item;

                                        const displayLabel =
                                            typeof item === "object"
                                                ? item.label
                                                : item;

                                        return (
                                            <label
                                                className="d-flex align-items-center mb-2 w-100"
                                                key={i}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    value={actualValue}
                                                    onChange={e => {

                                                        const value =
                                                            selectedColumn.DataType == "Text"
                                                                ? String(actualValue)
                                                                : selectedColumn.DataType == "Boolean"
                                                                    ? actualValue
                                                                    : isNaN(actualValue)
                                                                        ? actualValue
                                                                        : selectedColumn.DataType == "Url"
                                                                            ? actualValue
                                                                            : Number(actualValue);

                                                        selectFilter(
                                                            {
                                                                target: {
                                                                    ...e.target,
                                                                    value
                                                                }
                                                            },
                                                            selectedColumn.colName,
                                                            'values',
                                                            selectedColumn.DataType
                                                        );
                                                    }}
                                                    checked={
                                                        selectedFilters[selectedColumn.colName]?.values?.includes(
                                                            selectedColumn.DataType == "Text"
                                                                ? String(actualValue)
                                                                : selectedColumn.DataType == "Boolean"
                                                                    ? actualValue
                                                                    : selectedColumn.DataType == "Url"
                                                                        ? actualValue
                                                                        : Number(actualValue)
                                                        ) || false
                                                    }
                                                />

                                                <span className="ms-2">
                                                    {displayLabel}
                                                </span>
                                            </label>
                                        );
                                    })}
                                </Tab>
                                {selectedColumn?.DataType?.toLowerCase() == 'number' && (
                                    <Tab eventKey="Condition" title="Format">
                                        <div className="mb-2">
                                            <select
                                                className="form-select form-select-sm"
                                                value={conditionType}
                                                onChange={e => {
                                                    setConditionType(e.target.value);
                                                    setConditionValue({ from: '', to: '' });
                                                    handleConditionChange();
                                                }}
                                            >
                                                {['Equals', 'Does not equal', 'Greater than', 'Less than', 'Between', 'Blank', 'Not blank'].map(op => (
                                                    <option key={op} value={op}>{op}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {conditionType === 'Between' ? (
                                            <div className="d-flex gap-2 mb-2">
                                                <input
                                                    type="number"
                                                    placeholder="From"
                                                    className="form-control form-control-sm"
                                                    value={conditionValue.from}
                                                    onChange={(e) => {
                                                        const updated = { ...conditionValue, from: e.target.value };
                                                        setConditionValue(updated);
                                                    }}
                                                    onBlur={() => handleConditionChange()}
                                                />
                                                <input
                                                    type="number"
                                                    placeholder="To"
                                                    className="form-control form-control-sm"
                                                    value={conditionValue.to}
                                                    onChange={(e) => {
                                                        const updated = { ...conditionValue, to: e.target.value };
                                                        setConditionValue(updated);
                                                    }}
                                                    onBlur={() => handleConditionChange()}
                                                />
                                            </div>
                                        ) : !['Blank', 'Not blank'].includes(conditionType) && (
                                            <input
                                                type="number"
                                                placeholder="Value"
                                                className="form-control form-control-sm mb-2"
                                                value={conditionValue.from}
                                                onChange={(e) => {
                                                    const updated = { from: e.target.value, to: '' };
                                                    setConditionValue(updated);
                                                }}
                                                onBlur={() => handleConditionChange()}
                                            />
                                        )}
                                    </Tab>
                                )}

                            </Tabs>
                        </div>

                        {/* Sticky Buttons */}
                        <div className="d-flex justify-content-end gap-2 sticky-footer">
                            <Button size="sm" variant="secondary" className="search-button" onClick={() => applyFilter()}>
                                <FaSearch className="search-icon" />
                            </Button>
                            <Button size="sm" variant="secondary" className="search-button" onClick={clearFilters}>
                                <RiFilterOffLine className="search-icon" />
                            </Button>
                        </div>
                    </div>
                )
            }


            <ChartPopup visible={showChartPopup} setVisible={setsowChartPopup} objDs={data} />
        </>
    )
}
export default GlidGrid


